import React, { useEffect, useState } from "react";
import { IMillOnboardingContextProps } from "./MillOnboardingContextInterfaces";
import { initialState, MillOnboardingContext } from "./MillOnboardingContext";
import { MillsEntity } from "entities/Mills/MillsEntity";
import { removeCorporateOnboarding, setCorporateOnboarding } from "utilities/storageUtilities";

export const MillOnboardingContextProvider: React.FC<IMillOnboardingContextProps> = ({ children }) => {
    const [isMillOnboarding, setIsMillOnboarding] = useState<boolean>(initialState.isMillOnboarding);

    const isOnboardingFetch = async () => {
        const isOnboardingFetchResult = await MillsEntity.isMillOnboarding();
        setIsMillOnboarding(isOnboardingFetchResult);
        if (isOnboardingFetchResult) {
            setCorporateOnboarding(isOnboardingFetchResult);
        } else {
            if (initialState.isMillOnboarding) removeCorporateOnboarding();
        }
    };

    useEffect(() => {
        isOnboardingFetch();
    }, []);

    const providerValue = {
        isMillOnboarding,
        isOnboardingFetch,
    };

    return <MillOnboardingContext.Provider value={providerValue}>{children}</MillOnboardingContext.Provider>;
};
